export const DEFAULT_RATE_INPUTS = {tax1: "", tax2: ""};

export const formatRatePercentDisplay = (decimalRate) => ((decimalRate ?? 0) * 100).toFixed(3);

export const formatRateInputForModal = (decimalRate) => {
    if ((decimalRate ?? 0) === 0) {
        return "";
    }
    return formatRatePercentDisplay(decimalRate);
};

export const parseRatePercentInput = (displayValue) => {
    const parsed = parseFloat(displayValue);
    if (Number.isNaN(parsed)) {
        return 0;
    }
    return parsed / 100;
};

export const sanitizeRatePercentTyping = (value) => {
    if (value === "") {
        return "";
    }

    let sanitized = value.replace(/,/g, ".").replace(/[^\d.]/g, "");
    const dotIndex = sanitized.indexOf(".");
    if (dotIndex === -1) {
        return sanitized;
    }

    const whole = sanitized.slice(0, dotIndex);
    const fraction = sanitized.slice(dotIndex + 1).replace(/\./g, "");
    return `${whole}.${fraction}`;
};

export const roundRatePercentDisplay = (displayValue) => {
    const parsed = parseFloat(displayValue);
    if (Number.isNaN(parsed)) {
        return formatRatePercentDisplay(0);
    }
    return (Math.round(parsed * 1000) / 1000).toFixed(3);
};

export const prepareRateInputForEditing = (value) => {
    if (!value || value === "0.000" || parseRatePercentInput(value) === 0) {
        return "";
    }

    return roundRatePercentDisplay(value).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
};

export const formatRateInputOnBlur = (value) => {
    if (value === "" || value === ".") {
        return formatRatePercentDisplay(0);
    }
    return roundRatePercentDisplay(value);
};

export const buildRateInputsFromListRates = (listRates) => ({
    tax1: formatRateInputForModal(listRates?.[0]),
    tax2: formatRateInputForModal(listRates?.[1]),
});

export const applyRateInputsToListRates = (listRates, rateInputs) => [
    parseRatePercentInput(formatRateInputOnBlur(rateInputs.tax1)),
    parseRatePercentInput(formatRateInputOnBlur(rateInputs.tax2)),
];
